import { render, staticRenderFns } from "./HorizontalCheckBoxes.vue?vue&type=template&id=7d56080c&scoped=true&"
import script from "./HorizontalCheckBoxes.vue?vue&type=script&lang=js&"
export * from "./HorizontalCheckBoxes.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalCheckBoxes.vue?vue&type=style&index=0&id=7d56080c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d56080c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
installComponents(component, {
  VCheckbox,
})
